<template>
  <div id="shop-edition-product-item-picture">
    <div class="image-container" v-if="!uploading">
      <v-img
        :aspect-ratio="4 / 4"
        class="image grey lighten-2"
        cover
        :lazy-src="require('@/assets/NoPicture.png')"
        :src="downloadURL ? downloadURL : require('@/assets/NoPicture.png')"
      >
        <v-layout align-center fill-height justify-center ma-0 slot="placeholder">
          <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
        </v-layout>
      </v-img>
      <div class="overlay primary" @click="selectFile">
        <v-icon color="white" small>add_a_photo</v-icon>
      </div>
    </div>
    <input
      accept="image/*"
      @change="detectFiles($event)"
      id="files"
      :multiple="false"
      name="file"
      ref="uploadInput"
      style="display:none"
      type="file"
    />
    <v-progress-circular
      class="ma-2"
      color="primary"
      :rotate="360"
      :size="100"
      :value="progressUpload"
      v-if="uploading && !uploadEnd"
      :width="15"
      >{{ progressUpload }}%</v-progress-circular
    >
    <!-- <div v-if="uploadEnd">
      <v-btn @click="deleteImage()" class="ma-0" color="error" dark small>Delete</v-btn>
    </div>-->
  </div>
</template>

<script>
import firestorage from 'firebase/app' // Storage
export default {
  name: 'shop-edition-product-item-picture',
  props: {
    idx: {
      type: String,
      default: ''
    },
    condition: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      uploading: false,
      uploadEnd: false
    }
  },
  watch: {
    uploadTask() {
      this.uploadTask.on(
        'state_changed',
        sp => {
          this.progressUpload = Math.floor((sp.bytesTransferred / sp.totalBytes) * 100)
        },
        null,
        () => {
          // upload finish
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.uploading = false
            this.uploadEnd = true
            this.downloadURL = downloadURL
            // update into backend
            const data = {
              downloadURL: downloadURL,
              idx: this.idx
              // createdBy: localStorage.getItem('tokenAdmin')
            }
            this.$store.dispatch('ShopEditionProductItem/updatePicture', data)
            // reset file input
            const input = this.$refs.uploadInput
            input.type = 'text'
            input.type = 'file'
          })
        }
      )
    }
  },
  computed: {
    downloadURL: {
      // getter
      get() {
        return this.$store.getters['ShopEditionProductItem/getAll']
          .filter(item => item.idx == this.$store.state.ShopEditionProductItem.idx)
          .map(item => item.picture)[0]
      },
      // setter
      set() {}
    }
  },
  methods: {
    selectFile() {
      this.$refs.uploadInput.click()
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload(file) {
      // Upload images to firebase and get URL
      var storageRef = firestorage.storage().ref()

      this.fileName = file.name
      var ext = file.name.slice(file.name.lastIndexOf('.'))
      // Create the file metadata
      var metadata = {
        contentType: 'image/jpeg'
      }
      this.uploading = true
      this.uploadEnd = false
      this.uploadTask = storageRef
        .child(`images/shop/product-item/${window.btoa(this.idx)}${ext}`)
        .put(file, metadata)
    },
    deleteImage() {
      // var pictureRef = firestorage.storage().refFromURL(formData.picture)
      // // Delete in Firebase
      // pictureRef.delete().then(() => {
      //   // File deleted successfully
      // })
      firestorage
        .ref('images/' + this.fileName)
        .delete()
        .then(() => {
          this.uploading = false
          this.uploadEnd = false
          this.downloadURL = ''
        })
        .catch(error => {
          throw new Error(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  margin: 10px 0;
}
.image-container {
  position: relative;
  width: 100%;
  cursor: pointer;
}

.image {
  display: block;
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 6px;
  width: 30px;
  transition: 0.5s ease;
  opacity: 1;
  text-align: center;
  padding: 0px 0px 4px 0px;
  margin: 10px;
}

.image-container:hover .overlay {
  opacity: 1;
}
</style>
